import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, renderList as _renderList, withCtx as _withCtx, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" };
const _hoisted_2 = { class: "card-head box-shadow bg-white p-15 p-sm-20 p-md-25 d-flex align-items-center gap-3" };
const _hoisted_3 = { class: "card-title fw-bold mb-0" };
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" };
const _hoisted_5 = { class: "row g-4" };
const _hoisted_6 = { class: "col-md-6" };
const _hoisted_7 = { class: "col-md-6" };
const _hoisted_8 = { class: "input-group" };
const _hoisted_9 = { class: "col-12" };
const _hoisted_10 = { class: "col-12" };
const _hoisted_11 = { class: "d-flex align-items-center gap-3" };
const _hoisted_12 = {
    key: 0,
    class: "image-preview-container position-relative"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
    class: "text-muted extra-small mt-1 fw-bold text-uppercase",
    style: { "font-size": "10px" }
};
const _hoisted_15 = { class: "flex-grow-1" };
const _hoisted_16 = {
    key: 0,
    class: "progress mt-2",
    style: { "height": "4px" }
};
const _hoisted_17 = { class: "col-md-6" };
const _hoisted_18 = { class: "scope-selector" };
const _hoisted_19 = {
    key: 1,
    class: "col-md-6"
};
const _hoisted_20 = { class: "col-md-6" };
const _hoisted_21 = { class: "form-check form-switch d-flex align-items-center gap-2" };
const _hoisted_22 = {
    key: 2,
    class: "col-md-6"
};
const _hoisted_23 = { class: "timer-presets mb-2" };
const _hoisted_24 = ["onClick"];
const _hoisted_25 = { class: "input-group" };
const _hoisted_26 = { class: "text-muted" };
const _hoisted_27 = { class: "col-md-6" };
const _hoisted_28 = { class: "pricing-selector" };
const _hoisted_29 = { class: "col-12" };
const _hoisted_30 = { class: "mb-2" };
const _hoisted_31 = {
    key: 0,
    class: "text-muted"
};
const _hoisted_32 = {
    key: 1,
    class: "text-muted"
};
const _hoisted_33 = { class: "d-flex align-items-center gap-2" };
const _hoisted_34 = ["src"];
const _hoisted_35 = {
    key: 1,
    class: "ri-restaurant-line text-muted"
};
const _hoisted_36 = {
    key: 2,
    class: "text-muted ms-auto"
};
const _hoisted_37 = {
    key: 0,
    class: "selected-items"
};
const _hoisted_38 = { class: "selected-item__info" };
const _hoisted_39 = ["onClick"];
const _hoisted_40 = {
    key: 1,
    class: "text-muted small fst-italic"
};
const _hoisted_41 = { class: "col-12 d-flex gap-2 justify-content-end pt-2 border-top" };
const _hoisted_42 = ["disabled"];
const _hoisted_43 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
const _hoisted_44 = {
    key: 1,
    class: "ri-save-line me-1"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BreadCrumb = _resolveComponent("BreadCrumb");
    const _component_v_select = _resolveComponent("v-select");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_BreadCrumb, {
            PageTitle: _ctx.isEdit ? 'Modifier le produit fidélité' : 'Créer un produit fidélité'
        }, null, 8, ["PageTitle"]),
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("button", {
                    class: "btn btn-sm btn-outline-secondary",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$router.back()))
                }, [...(_cache[18] || (_cache[18] = [
                        _createElementVNode("i", { class: "ri-arrow-left-line" }, null, -1),
                        _createTextVNode(" Retour ", -1)
                    ]))]),
                _createElementVNode("h5", _hoisted_3, [
                    _cache[19] || (_cache[19] = _createElementVNode("i", { class: "ri-gift-line me-2 text-primary" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.isEdit ? 'Modifier la récompense fidélité' : 'Nouvelle récompense fidélité'), 1)
                ])
            ]),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("form", {
                    onSubmit: _cache[17] || (_cache[17] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
                }, [
                    _createElementVNode("div", _hoisted_5, [
                        _cache[45] || (_cache[45] = _createElementVNode("div", { class: "col-12" }, [
                            _createElementVNode("div", { class: "section-header" }, [
                                _createElementVNode("i", { class: "ri-information-line" }),
                                _createTextVNode(" Informations de base ")
                            ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_6, [
                            _cache[20] || (_cache[20] = _createElementVNode("label", { class: "form-label required-label" }, "Nom de la récompense", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.form.name) = $event)),
                                type: "text",
                                class: "form-control",
                                placeholder: "Ex: Pizza Offerte, Menu Duo Offert...",
                                required: ""
                            }, null, 512), [
                                [_vModelText, _ctx.form.name]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _cache[23] || (_cache[23] = _createElementVNode("label", { class: "form-label required-label" }, "Points requis", -1)),
                            _createElementVNode("div", _hoisted_8, [
                                _cache[21] || (_cache[21] = _createElementVNode("span", { class: "input-group-text" }, [
                                    _createElementVNode("i", { class: "ri-coins-line" })
                                ], -1)),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.form.pointsCost) = $event)),
                                    type: "number",
                                    class: "form-control",
                                    min: "1",
                                    placeholder: "1500",
                                    required: ""
                                }, null, 512), [
                                    [
                                        _vModelText,
                                        _ctx.form.pointsCost,
                                        void 0,
                                        { number: true }
                                    ]
                                ]),
                                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "input-group-text" }, "pts", -1))
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _cache[24] || (_cache[24] = _createElementVNode("label", { class: "form-label" }, "Description", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.form.description) = $event)),
                                class: "form-control",
                                rows: "2",
                                placeholder: "Décrivez la récompense pour le client..."
                            }, null, 512), [
                                [_vModelText, _ctx.form.description]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                            _cache[28] || (_cache[28] = _createElementVNode("label", { class: "form-label" }, "Image de la récompense", -1)),
                            _createElementVNode("div", _hoisted_11, [
                                (_ctx.form.imageUrl)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                        _createElementVNode("img", {
                                            src: _ctx.form.imageUrl,
                                            alt: "Preview",
                                            class: "rounded shadow-sm",
                                            style: { "width": "80px", "height": "80px", "object-fit": "cover" }
                                        }, null, 8, _hoisted_13),
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-sm btn-danger position-absolute top-0 end-0 p-0 rounded-circle",
                                            style: { "width": "20px", "height": "20px", "font-size": "10px" },
                                            onClick: _cache[4] || (_cache[4] = ($event) => { _ctx.form.imageUrl = ''; _ctx.selectedFile = null; })
                                        }, [...(_cache[25] || (_cache[25] = [
                                                _createElementVNode("i", { class: "ri-close-line" }, null, -1)
                                            ]))])
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: "upload-placeholder d-flex flex-column align-items-center justify-content-center rounded border-2 border-dashed px-2 text-center",
                                        style: { "width": "140px", "height": "100px", "background": "#f8f9fa", "cursor": "pointer", "border-color": "#dee2e6" },
                                        onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.fileInput?.click()))
                                    }, [
                                        _cache[26] || (_cache[26] = _createElementVNode("i", { class: "ri-image-add-line fs-2 text-muted" }, null, -1)),
                                        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.uploadingImage ? 'Envoi...' : 'Upload Image'), 1),
                                        _createElementVNode("input", {
                                            type: "file",
                                            ref: "fileInput",
                                            class: "d-none",
                                            accept: "image/*",
                                            onChange: _cache[5] || (_cache[5] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleImageUpload && _ctx.handleImageUpload(...args)))
                                        }, null, 544)
                                    ])),
                                _createElementVNode("div", _hoisted_15, [
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.form.imageUrl) = $event)),
                                        type: "url",
                                        class: "form-control",
                                        placeholder: "Ou entrez une URL directe..."
                                    }, null, 512), [
                                        [_vModelText, _ctx.form.imageUrl]
                                    ]),
                                    (_ctx.uploadingImage)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[27] || (_cache[27] = [
                                                _createElementVNode("div", {
                                                    class: "progress-bar progress-bar-striped progress-bar-animated",
                                                    style: { "width": "100%" }
                                                }, null, -1)
                                            ]))]))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ]),
                        (!_ctx.isScopeEnforced)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _cache[32] || (_cache[32] = _createElementVNode("div", { class: "col-12" }, [
                                    _createElementVNode("div", { class: "section-header" }, [
                                        _createElementVNode("i", { class: "ri-global-line" }),
                                        _createTextVNode(" Portée de la récompense ")
                                    ])
                                ], -1)),
                                _createElementVNode("div", _hoisted_17, [
                                    _cache[31] || (_cache[31] = _createElementVNode("label", { class: "form-label required-label" }, "Portée", -1)),
                                    _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["scope-option", { 'scope-option--active': _ctx.form.scope === 'GLOBAL' }]),
                                            onClick: _cache[8] || (_cache[8] = ($event) => { _ctx.form.scope = 'GLOBAL'; _ctx.form.restaurantId = null; })
                                        }, [...(_cache[29] || (_cache[29] = [
                                                _createElementVNode("i", { class: "ri-global-line scope-option__icon" }, null, -1),
                                                _createElementVNode("div", null, [
                                                    _createElementVNode("strong", null, "GLOBAL"),
                                                    _createElementVNode("p", null, [
                                                        _createTextVNode("Tous les restaurants de la franchise."),
                                                        _createElementVNode("br"),
                                                        _createElementVNode("small", null, "L'item survit au changement de restaurant.")
                                                    ])
                                                ], -1)
                                            ]))], 2),
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["scope-option", { 'scope-option--active': _ctx.form.scope === 'LOCAL' }]),
                                            onClick: _cache[9] || (_cache[9] = ($event) => (_ctx.form.scope = 'LOCAL'))
                                        }, [...(_cache[30] || (_cache[30] = [
                                                _createElementVNode("i", { class: "ri-store-line scope-option__icon" }, null, -1),
                                                _createElementVNode("div", null, [
                                                    _createElementVNode("strong", null, "LOCAL"),
                                                    _createElementVNode("p", null, [
                                                        _createTextVNode("Restaurant spécifique uniquement."),
                                                        _createElementVNode("br"),
                                                        _createElementVNode("small", null, "Comportement classique (lié au restaurant).")
                                                    ])
                                                ], -1)
                                            ]))], 2)
                                    ])
                                ])
                            ], 64))
                            : _createCommentVNode("", true),
                        (_ctx.form.scope === 'LOCAL')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _cache[33] || (_cache[33] = _createElementVNode("label", { class: "form-label required-label" }, "Restaurant", -1)),
                                _createVNode(_component_v_select, {
                                    modelValue: _ctx.form.restaurantId,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.form.restaurantId) = $event)),
                                    options: _ctx.restaurantOptions,
                                    label: "name",
                                    reduce: (r) => r.id,
                                    placeholder: "Sélectionner le restaurant"
                                }, null, 8, ["modelValue", "options", "reduce"])
                            ]))
                            : _createCommentVNode("", true),
                        _cache[46] || (_cache[46] = _createElementVNode("div", { class: "col-12" }, [
                            _createElementVNode("div", { class: "section-header" }, [
                                _createElementVNode("i", { class: "ri-timer-line" }),
                                _createTextVNode(" Timer & Expiration (modèle MCDO) ")
                            ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.form.cartExpiryEnabled) = $event)),
                                    class: "form-check-input",
                                    type: "checkbox",
                                    id: "expiryEnabled",
                                    style: { "width": "44px", "height": "22px" }
                                }, null, 512), [
                                    [_vModelCheckbox, _ctx.form.cartExpiryEnabled]
                                ]),
                                _cache[34] || (_cache[34] = _createElementVNode("label", {
                                    class: "form-check-label fw-semibold",
                                    for: "expiryEnabled"
                                }, " Activer le timer d'expiration ", -1))
                            ]),
                            _cache[35] || (_cache[35] = _createElementVNode("small", { class: "text-muted ms-5" }, [
                                _createTextVNode(" Le timer démarre à l'"),
                                _createElementVNode("strong", null, "ajout au panier"),
                                _createTextVNode(". ")
                            ], -1))
                        ]),
                        (_ctx.form.cartExpiryEnabled)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _cache[37] || (_cache[37] = _createElementVNode("label", { class: "form-label" }, "Durée du timer", -1)),
                                _createElementVNode("div", _hoisted_23, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timerPresets, (preset) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                            key: preset.seconds,
                                            type: "button",
                                            class: _normalizeClass(["btn btn-sm", _ctx.form.cartExpiryDuration === preset.seconds ? 'btn-primary' : 'btn-outline-secondary']),
                                            onClick: ($event) => (_ctx.form.cartExpiryDuration = preset.seconds)
                                        }, _toDisplayString(preset.label), 11, _hoisted_24));
                                    }), 128))
                                ]),
                                _createElementVNode("div", _hoisted_25, [
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.form.cartExpiryDuration) = $event)),
                                        type: "number",
                                        class: "form-control",
                                        min: "60",
                                        max: "86400"
                                    }, null, 512), [
                                        [
                                            _vModelText,
                                            _ctx.form.cartExpiryDuration,
                                            void 0,
                                            { number: true }
                                        ]
                                    ]),
                                    _cache[36] || (_cache[36] = _createElementVNode("span", { class: "input-group-text" }, "secondes", -1))
                                ]),
                                _createElementVNode("small", _hoisted_26, " = " + _toDisplayString(_ctx.formatDuration(_ctx.form.cartExpiryDuration)), 1)
                            ]))
                            : _createCommentVNode("", true),
                        _cache[47] || (_cache[47] = _createElementVNode("div", { class: "col-12" }, [
                            _createElementVNode("div", { class: "section-header" }, [
                                _createElementVNode("i", { class: "ri-price-tag-3-line" }),
                                _createTextVNode(" Tarification des options & suppléments ")
                            ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_27, [
                            _cache[40] || (_cache[40] = _createElementVNode("label", { class: "form-label" }, "Options et suppléments", -1)),
                            _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(["pricing-option", { 'pricing-option--active': _ctx.form.optionsPricing === 'FREE' }]),
                                    onClick: _cache[13] || (_cache[13] = ($event) => (_ctx.form.optionsPricing = 'FREE'))
                                }, [...(_cache[38] || (_cache[38] = [
                                        _createElementVNode("i", { class: "ri-check-double-line text-success" }, null, -1),
                                        _createElementVNode("div", null, [
                                            _createElementVNode("strong", null, "FREE — Inclus"),
                                            _createElementVNode("p", null, [
                                                _createTextVNode("Options et suppléments "),
                                                _createElementVNode("strong", null, "sans surcoût"),
                                                _createTextVNode(" pour le client.")
                                            ])
                                        ], -1)
                                    ]))], 2),
                                _createElementVNode("div", {
                                    class: _normalizeClass(["pricing-option", { 'pricing-option--active': _ctx.form.optionsPricing === 'STANDARD' }]),
                                    onClick: _cache[14] || (_cache[14] = ($event) => (_ctx.form.optionsPricing = 'STANDARD'))
                                }, [...(_cache[39] || (_cache[39] = [
                                        _createElementVNode("i", { class: "ri-money-euro-circle-line text-warning" }, null, -1),
                                        _createElementVNode("div", null, [
                                            _createElementVNode("strong", null, "STANDARD — Facturés"),
                                            _createElementVNode("p", null, "Options facturées normalement en supplément.")
                                        ], -1)
                                    ]))], 2)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                            _cache[43] || (_cache[43] = _createElementVNode("div", { class: "section-header" }, [
                                _createElementVNode("i", { class: "ri-restaurant-line" }),
                                _createTextVNode(" Produits disponibles au choix ")
                            ], -1)),
                            _cache[44] || (_cache[44] = _createElementVNode("p", { class: "text-muted small mb-3" }, " Sélectionnez les produits que le client peut choisir parmi cette récompense (ex: toutes vos pizzas). ", -1)),
                            _createElementVNode("div", _hoisted_30, [
                                _createVNode(_component_v_select, {
                                    modelValue: _ctx.selectedCatalogProduct,
                                    "onUpdate:modelValue": [
                                        _cache[15] || (_cache[15] = ($event) => ((_ctx.selectedCatalogProduct) = $event)),
                                        _ctx.addCatalogProduct
                                    ],
                                    options: _ctx.catalogProducts,
                                    label: "name",
                                    placeholder: _ctx.isSearchDisabled ? '⚠️ Sélectionnez d\'abord un restaurant (Mode LOCAL)' : 'Rechercher un produit (ex: Pizza, Burger...)',
                                    onSearch: _ctx.onSearchProducts,
                                    loading: _ctx.searchingProducts,
                                    disabled: _ctx.isSearchDisabled,
                                    class: "mb-2"
                                }, {
                                    "no-options": _withCtx(({ search, searching }) => [
                                        searching
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_31, "Recherche de \"" + _toDisplayString(search) + "\"...", 1))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_32, "Tapez pour rechercher un produit"))
                                    ]),
                                    option: _withCtx((option) => [
                                        _createElementVNode("div", _hoisted_33, [
                                            (option.imageUrl)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: option.imageUrl,
                                                    class: "rounded",
                                                    style: { "width": "24px", "height": "24px", "object-fit": "cover" }
                                                }, null, 8, _hoisted_34))
                                                : (_openBlock(), _createElementBlock("i", _hoisted_35)),
                                            _createElementVNode("span", null, _toDisplayString(option.name), 1),
                                            (option.restaurantId)
                                                ? (_openBlock(), _createElementBlock("small", _hoisted_36, "(Local)"))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    _: 1
                                }, 8, ["modelValue", "options", "placeholder", "onSearch", "onUpdate:modelValue", "loading", "disabled"])
                            ]),
                            (_ctx.form.availableItems.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.availableItems, (item, idx) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: idx,
                                            class: "selected-item"
                                        }, [
                                            _createElementVNode("div", _hoisted_38, [
                                                _cache[41] || (_cache[41] = _createElementVNode("i", { class: "ri-restaurant-line text-primary me-2" }, null, -1)),
                                                _createElementVNode("span", null, _toDisplayString(item.productName), 1)
                                            ]),
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn-sm btn-outline-danger d-flex align-items-center justify-content-center",
                                                style: { "width": "38px", "height": "38px", "border-width": "2px" },
                                                onClick: ($event) => (_ctx.removeItem(idx)),
                                                title: "Retirer"
                                            }, [...(_cache[42] || (_cache[42] = [
                                                    _createElementVNode("i", { class: "flaticon-delete fw-bold fs-5" }, null, -1)
                                                ]))], 8, _hoisted_39)
                                        ]));
                                    }), 128))
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_40, " Aucun produit sélectionné — le client aura accès à tous les produits du restaurant. "))
                        ]),
                        _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-outline-secondary",
                                onClick: _cache[16] || (_cache[16] = ($event) => (_ctx.$router.back()))
                            }, " Annuler "),
                            _createElementVNode("button", {
                                type: "submit",
                                class: "btn btn-primary",
                                disabled: _ctx.saving
                            }, [
                                (_ctx.saving)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_43))
                                    : (_openBlock(), _createElementBlock("i", _hoisted_44)),
                                _createTextVNode(" " + _toDisplayString(_ctx.isEdit ? 'Enregistrer les modifications' : 'Créer la récompense'), 1)
                            ], 8, _hoisted_42)
                        ])
                    ])
                ], 32)
            ])
        ])
    ], 64));
}
